import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import constants from "../../assets/constants";
import * as AdminSessionActions from "../../state/redux/adminSession";
import * as PatientSessionActions from "../../state/redux/patientSession";
import { deepCopyObject } from "../../utils/helpers";
import AssessmentWizardDialog from "../dialogs/assessmentWizardDialog";
import UserDialog from "../dialogs/userDialog";
import OmniResponsiveButton from "../ui/omniResponsiveButton";
import SurveyPatients from "../ui/surveyPatients";
import Widget from "../ui/widget";
import WidgetSkeleton from "../ui/widgetSkeleton";
import WidgetSurveyContent from "../ui/widgetSurveyContent";
import WidgetTitle from "../ui/widgetTitle";

const AdminPatients = props => {
  const {
    loadPatientsRequest,
    patientODMs,
    patientPageLoading,
    patientPagination,
    userODM,
    awsGroup,
  } = props;

  useEffect(() => {
    if (patientODMs != null) {
      setRows(patientODMs);
    }
  }, [patientODMs]);
  const [showAssessmentDialog, setShowAssessmentDialog] = useState(null);

  const [selectedPatient, setSelectedPatient] = useState(null);

  const [rows, setRows] = useState([]);

  const [titleText, setTitleText] = useState(null);

  useEffect(() => {
    if (patientPagination != null) {
      setTitleText(
        `${patientPagination.totalItems} Candidate${patientPagination.totalItems === 1 ? "" : "s"}`,
      );
    } else {
      setTitleText("Loading...");
    }
    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientPagination]);

  return (
    <Widget>
      <WidgetTitle title={"Patients"} text={titleText}>
        <OmniResponsiveButton
          tooltipTitle="Add a new trial candidate"
          buttonText="Candidate"
          onClick={() => {
            setShowAssessmentDialog(constants.assessmentIDs.omniHealthHistory);
          }}
        />
      </WidgetTitle>

      {rows == null && <WidgetSkeleton />}
      {rows != null && (
        <WidgetSurveyContent>
          <SurveyPatients
            patientODMs={rows}
            onEditPatient={setSelectedPatient}
            onRequestNewPage={loadPatientsRequest}
            isLoading={patientPageLoading}
            patientPagination={patientPagination}
          />
        </WidgetSurveyContent>
      )}

      {selectedPatient && (
        <UserDialog
          open={selectedPatient != null}
          dialogTitle={`${selectedPatient._id == null ? "Add" : "Edit"} Patient`}
          omniODM={deepCopyObject(selectedPatient)}
          providerId={awsGroup === constants.userGroups.Provider ? userODM._id : null}
          onDelete={patient_id => {
            props.deletePatientRequest(patient_id);
            setSelectedPatient(null);
          }}
          onAccept={patient => {
            props.updatePatientRequest(patient);
            setSelectedPatient(null);
          }}
          onClose={() => {
            setSelectedPatient(null);
          }}
        />
      )}
      {showAssessmentDialog != null && (
        <AssessmentWizardDialog
          open={showAssessmentDialog != null}
          // lockAssessmentOmniType={showAssessmentDialog}
          // autoStartAssessment={true}
          onClose={() => {
            setShowAssessmentDialog(null);
          }}
        />
      )}
    </Widget>
  );
};
const mapStateToProps = state => ({
  patientODMs: state.adminSession.patientODMs,
  patientPageLoading: state.adminSession.patientPageLoading,
  patientPagination: state.adminSession.patientPagination,

  awsGroup: state.userSession.awsGroup,
  userODM: state.userSession.userODM,
});

const mapDispatchToProps = {
  loadPatientsRequest: AdminSessionActions.loadPatientsRequest,

  deletePatientRequest: PatientSessionActions.deletePatientRequest,
  updatePatientRequest: PatientSessionActions.updatePatientRequest,
  setPatientODMRequest: PatientSessionActions.setPatientODMRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AdminPatients));
